export default __webpack_public_path__ + "static/media/@robertapazulini.92f3a13c.jpg";